import React, { Component } from 'react';
import LoginForm from '../components/views/Login/LoginForm';

export default LoginForm;
